export default "__VITE_PUBLIC_ASSET__36fe0aa6__"